import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class TransitProgram extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  organizationId: number;

  @autoserialize
  stateCode: string;

  @autoserialize
  timeZone: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserialize
  ftaCompliant: boolean;

  @autoserialize
  active: boolean;

  @autoserialize
  maximumVehicleAgeInYears: number;

  @autoserialize
  acceptingDrivers: boolean;

  @autoserialize
  acceptingRides: boolean;

  @autoserialize
  driverHubLink: string;

  @autoserialize
  onboardingGuideLink: string;
}
